// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"icon_wrapper__epDGT"};